<template>
  <div class="funnel-card">
    <div class="card-header">
      <div class="card-header-left">
        <p class="card-header-title">{{title}}</p>
        <i class="separator"></i>
        <p class="card-header-dataDesc">{{dataDesc}}</p>
      </div>
    </div>
    <div class="card-body">
      <div class="card-body-inner">
        <div class="card-body-header">
          <div class="date">
            <p class="date-label">{{dateLabel}}</p>
            <p class="date-value">{{dateValue}}</p>
          </div>
          <div class="tabs" v-if="tabs.length">
            <el-radio-group :value="currentTab" size="small" @input="handleTabChange">
              <el-radio-button v-for="(item) in tabs" :label="item.value" :key="item.label">{{item.label}}</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div v-if="dataList.length" class="data-list">
          <template v-for="(data, index) in dataList">
            <div :class="{
              'data-card': true,
            }" :key="data.label">
              <div class="data-label" @click="handleDataValueClick(data.clickCallback)">{{index + 1}}.{{data.label}}</div>
              <div class="data-detail">
                <div class="data-detail-top data-ratio-wrapper" style="width: 100%">
                  <div class="data-ratio" :style="{width: (data.value * 100) + '%'}"></div>
                </div>
                <div class="data-detail-bottom" v-show="data.showRatio !== false">
                  <div class="data-value">{{(data.value * 100).toFixed(2) + '%'}}</div>
                  <div class="data-change-situation-list" v-if="ratioConfig.showRatio && Array.isArray(data.ratioList) && data.ratioList.length">
                    <p class="data-change-situation" v-for="(item, index) in data.ratioList" :key="index">
                      <span class="situation-label">{{item.name}}</span>
                      <i :class="{
                        'situation-icon': true,
                        increase: item.value > 0,
                        decrease: item.value < 0
                      }"></i>
                      <span :class="{
                        'situation-value': true,
                        increase: item.value > 0,
                        decrease: item.value < 0
                      }">{{item.value === null || typeof item.value === 'undefined' ? '--' : (item.value * 100).toFixed(2).replace('-', '') + '%'}}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['ratioConfig'],
  props: {
    // 标题
    title: {
      type: String,
      default: '',
    },
    // 数据描述
    dataDesc: {
      type: String,
      default: '',
    },
    // 日期标签
    dateLabel: {
      type: String,
      default: '',
    },
    // 日期值
    dateValue: {
      type: String,
      default: '',
    },
    // 当前tab
    currentTab: {
      type: [String, Number],
    },
    // tab列表
    tabs: {
      type: Array,
      default: () => [],
    },
    // 数据列表
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleTabChange(tab) {
      this.$emit('tabChange', tab)
    },
    handleDataValueClick(callback) {
      typeof callback === 'function' && callback()
    },
  },
}
</script>
<style lang="scss" scoped>
.funnel-card {
  border-radius: 2px;
  overflow: hidden;
  .card-header {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 38px;
    padding: 8px 12px;
    background: #F8F8FA;
    &::before {
      position: absolute;
      top: 50%;
      left: 0;
      margin-top: -9px;
      content: '';
      width: 3px;
      height: 18px;
      background: #0256FF;
      border-radius: 10px;
    }
    .card-header-left {
      display: flex;
      align-items: center;
      .card-header-title {
        font-size: 14px;
        font-weight: 600;
        line-height: 22px;
        color: #3D3D3D;
      }
      .card-header-dataDesc {
        font-size: 12px;
        font-weight: normal;
        line-height: 22px;
        color: #767676;
      }
      .separator {
        width: 1px;
        height: 10px;
        margin: 0 6px;
        flex: none;
        background: #767676;
      }
      .card-header-dataUpdateTime {
        font-size: 12px;
        font-weight: normal;
        line-height: 22px;
        color: #767676;
      }
    }
  }
  .card-body {
    display: flex;
    width: 100%;
    border: 1px solid #ECEEF4;
    border-top: none;
    .card-body-inner {
      display: flex;
      flex-direction: column;
      width: 100%;
      .card-body-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 40px 24px 26px;
        .date {
          display: flex;
          flex-direction: column;
          .date-label {
            margin: 0;
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
            color: #3D3D3D;
          }
          .date-value {
            margin: 0;
            margin-top: 4px;
            font-size: 14px;
            font-weight: normal;
            line-height: 22px;
            color: #767676;
          }
        }
        .tabs {
          margin-top: 4px;
        }
      }
      .data-list {
        display: flex;
        flex-direction: column;
        padding: 0 40px 8px 26px;
        overflow: hidden;
      }
    }
    .data-card {
      display: flex;
      align-items: flex-start;
      margin-bottom: 16px;
      .data-label {
        flex: none;
        width: 82px;
        margin-right: 16px;
        font-size: 14px;
        font-weight: normal;
        line-height: 22px;
        color: #3D3D3D;
      }
      .data-detail {
        flex: 1;
        .data-ratio-wrapper {
          display: flex;
          height: 22px;
          background: #D8D8D8;
          border-radius: 4px;
          .data-ratio {
            height: 22px;
            background: #568CF7;
            border-radius: 4px;
            transition: width 0.3s ease-in-out;
          }
        }
        .data-detail-bottom {
          display: flex;
          margin-top: 8px;
          .data-value {
            position: relative;
            display: flex;
            justify-content: center;
            flex: none;
            width: 74px;
            height: 32px;
            padding-top: 3px;
            font-size: 16px;
            font-weight: normal;
            line-height: 22px;
            color: #3D3D3D;
            background: url('../../../../assets/img/funnel_data_bg.png') 0 0 no-repeat;
            background-size: 100%;
            border-radius: 2px;
            box-sizing: border-box;
          }
          .data-change-situation-list {
            display: flex;
            .data-change-situation {
              margin: 0 0 0 20px;
              display: flex;
              align-items: center;
              .situation-label {
                flex: none;
                font-size: 12px;
                font-weight: normal;
                line-height: 22px;
                color: #767676;
              }
              .situation-icon {
                flex: none;
                margin: 0 2px 0 4px;
                &.increase {
                  width: 10px;
                  height: 7px;
                  background: url('../../../../assets/img/ratio_up.png') 0 0 no-repeat;
                  background-size: 100%;
                }
                &.decrease {
                  width: 10px;
                  height: 7px;
                  background: url('../../../../assets/img/ratio_down.png') 0 0 no-repeat;
                  background-size: 100%;
                }
              }
              .situation-value {
                &.increase {
                  font-size: 12px;
                  font-weight: normal;
                  line-height: 14px;
                  color: #0FC570;
                }
                &.decrease {
                  font-size: 12px;
                  font-weight: normal;
                  line-height: 14px;
                  color: #EA0000;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
